import { QueryClient } from '@tanstack/react-query';

type CartListItem = {
  id: string;
  quantity: number;
  note?: string | null;
};

type CartPatch = {
  quantity?: number;
  note?: CartListItem['note'];
};

/**
 * Updates any cached `['Cart', ...]` React Query results in-place for a single item.
 *
 * This prevents long-lived UI drift because `useCartDataFetch` uses a 5 minute `staleTime`,
 * meaning UI that reads from `item.note` / `item.quantity` can remain stale unless we
 * proactively update the cache after successful PATCH calls.
 */
export const patchCartItemInCartQueries = (
  queryClient: QueryClient,
  itemId: string,
  patch: CartPatch
) => {
  queryClient.setQueriesData<CartListItem[]>(
    {
      queryKey: ['Cart'],
    },
    (old) => {
      if (!old) return old;
      return old.map((item) => {
        if (item.id !== itemId) return item;
        return {
          ...item,
          ...(patch.quantity !== undefined ? { quantity: patch.quantity } : {}),
          ...(patch.note !== undefined ? { note: patch.note } : {}),
        };
      });
    }
  );
};
